import { PlusCircle, UserPlus } from 'lucide-react';
import { Button } from '../ui/Button'; 
import storage from '../../utils/storage';
import { useNavigate } from 'react-router-dom';

export default function UserHeader({ title, subtitle, totalUsers, description, onAddUser, onCreate, createLabel = 'Nouveau sondage' }) {
  const role = storage.getRole();
  const navigate = useNavigate();

  const shouldRenderActions = (role === 'ADMIN' && onAddUser) || (role === 'GERANT' && onCreate);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <h1 className="font-display text-2xl font-bold text-foreground">{title}</h1>
        {description ? (
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
        ) : (
          subtitle && (
            <p className="text-sm text-muted-foreground mt-1">{totalUsers ?? 0} {subtitle}</p>
          )
        )}
      </div>

      {shouldRenderActions && (
        <div className="flex items-center gap-2">
          {role === 'ADMIN' && onAddUser && (
            <Button className="gap-2 font-semibold" onClick={onAddUser}>
              <UserPlus className="h-4 w-4" />
              Ajouter un gestionnaire
            </Button>
          )}
          {role === 'GERANT' && onCreate && (
            <Button onClick={onCreate} className="gap-2 font-semibold">
              <PlusCircle className="h-4 w-4" />
              {createLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
